/**
 * NOTE: Please ensure the SCSS definitions are kept up to date if these change
 * ./breakpoints.scss
 */
export const BREAKPOINT_SMALL = 576;
export const BREAKPOINT_MEDIUM = 768;
export const BREAKPOINT_LARGE = 992;
export const BREAKPOINT_XLARGE = 1200;
export const BREAKPOINT_XXLARGE = 1400;
